import { useState, useEffect, useMemo } from 'react';
import { useSelector } from '@hotjar/recordings/src/store/player/context';
import { LocalStorage } from '@hotjar/insights-common/lib/storage-factory';
import { useAccountTrialInfo } from '@hotjar/account';
import { isOnActiveOrEligibleTrial } from '@hotjar/subscription-management';
import { getSiteId } from '@hotjar/webapp/features/Playbacks/store/utils';
import { isSiteOnScaleOrScaleTrial } from '../../../utils/isSiteOnScaleOrScaleTrial';

const FEATURE_KEY = 'error_reporting';

export const useIsConsoleAvailable = (): boolean => {
  const siteId = useMemo(getSiteId, []);
  const [isAvailable, setIsAvailable] = useState(() =>
    LocalStorage.get(`${FEATURE_KEY}-${siteId}`, false),
  );

  const trialInfo = useAccountTrialInfo();
  const { site } = useSelector(({ site }) => ({ site }));

  useEffect(() => {
    if (!site || !trialInfo) return;

    const isConsoleAvailable = isSiteOnScaleOrScaleTrial({
      ...site,
      trial: { active: isOnActiveOrEligibleTrial(trialInfo) },
    });

    LocalStorage.set(`${FEATURE_KEY}-${site.id}`, isConsoleAvailable);
    setIsAvailable(isConsoleAvailable);
  }, [site, trialInfo]);

  return isAvailable;
};
